import {useSelector} from "react-redux";
import {getPropRateExpectation} from "../../ducks/ratesReducer.js";
import Counter from "../util/Counter.jsx";
import './PropRatesExpectation.scss'

export default () => {

    const {expectedDaysToNewPropertyRates, daysSinceLatestPropertyRates} = useSelector(getPropRateExpectation) || {}

    if (daysSinceLatestPropertyRates <= 3) {
        return (
            <Content>
                <em>New property rates</em> available now
            </Content>
        )
    }

    if (expectedDaysToNewPropertyRates <= 1) {
        return (
            <Content>
                Expected property rates <em>any day</em>
            </Content>
        )
    }

    return expectedDaysToNewPropertyRates <= 7 && (
        <Content>
            Expected property rates in <Counter amount={expectedDaysToNewPropertyRates}/> days
        </Content>
    )
}

const Content = ({children}) => {
    return (
        <div className='expected-property-rates'>
            <div className='content'>
                {children}
            </div>
        </div>
    )
}